import { render } from "./ApprovalRequests.vue?vue&type=template&id=6ce106f3&scoped=true"
import script from "./ApprovalRequests.vue?vue&type=script&lang=js"
export * from "./ApprovalRequests.vue?vue&type=script&lang=js"

import "./ApprovalRequests.vue?vue&type=style&index=0&id=6ce106f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce106f3"]])

export default __exports__